import React, { useEffect, useState } from "react";
import "./styles.css";
import { useSelector } from "react-redux";
import api from "../../../services/api";
import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";

export default function MinhasVagas() {
  const [minhasCandidaturas, setMinhasCandidaturas] = useState([]);
  const profile = useSelector((state) => {
    if (state?.user?.profile?.dataValues) {
      return state.user.profile.dataValues;
    } else {
      return state.user.profile || {};
    }
  });
  async function getVagasCandidatadas() {
    try {
      const response = await api.get("/candidatura/minhas");
      setMinhasCandidaturas(response.data);
    } catch (error) {
      console.error("Erro ao buscar candidaturas", error);
      return [];
    }
  }

  useEffect(() => {
    getVagasCandidatadas();
  });

  function dataFormat(apiResponseDate) {
    const formattedDate = format(parseISO(apiResponseDate), "dd/MM/yyyy");
    return formattedDate;
  }

  return (
    <div className="minhas-vagas-container">
      <div className="minhas-vagas-header">
        <h2 className="minhas-vagas-title">Minhas vagas</h2>
        <Link to="/oxetechwork" className="ver-todas-button">
          Ver todas
        </Link>
      </div>

      <div className="vagas-grid">
        {minhasCandidaturas.map((vaga) => (
          <div key={vaga.id} className="vaga-card">
            <div className="search-icon-container">
              <svg
                className="search-icon"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </div>
            <h3 className="vaga-titulo">{vaga.Vaga.titulo}</h3>
            <p className="vaga-empresa">{vaga.empresa}</p>
            <p className="vaga-status">
              Inscrito em {dataFormat(vaga.updatedAt)}
            </p>
            <button className="editar-button">Editar (em breve)</button>
          </div>
        ))}
      </div>
    </div>
  );
}
